<template>
  <v-container
    fluid
    tag="section"
  >
    <v-row>
      <v-col class="d-flex justify-sm-space-around justify-center flex-wrap">
        <v-card
          v-for="upAccountCampaign in upAccountCampaignList"
          :key="upAccountCampaign.account.AccountId"
          elevation="6"
          class="ma-1 pa-0 d-flex flex-column justify-space-between"
          min-width="19rem"
          min-height="180px"
          width="25vw"
        >
          <!--        <v-input :label="upAccountCampaign.account.Amount" />-->
          <!--        <v-input :label="upAccountCampaign.campaign.name" />-->
          <v-card-text
            class="d-flex flex-column align-center pa-1"
          >
            <v-row class="campaign-border align-self-stretch ma-2">
              <v-col class="ma-0 pa-2">
                <v-row class="ma-1">
                  <v-col
                    class="text-center pa-2 campaign-name"
                  >
                    {{ upAccountCampaign.campaign.name }}
                  </v-col>
                </v-row>
                <v-row class="ma-1">
                  <v-col class="blue--text text--lighten-1 font-italic text-center pa-0">
                    {{ upAccountCampaign.campaign.description }}
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-center ma-0">
                Дата регистрации: {{ upAccountCampaign.campaign.createDate }}
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                накоплено
              </v-col>
            </v-row>
            <v-row>
              <v-col class="display-3 loyalty-amount">
                {{ upAccountCampaign.account.Amount }} руб.
              </v-col>
            </v-row>
            <v-row>
              <v-col class="loyalty-bonus">
                БОНУСОВ
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="d-flex flex-row justify-end">
            <v-btn
              color="success"
              @click="onGetTransaction(upAccountCampaign.campaign)"
            >
              <v-icon>
                mdi-shopping-outline
              </v-icon>
              ПОКУПКИ
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { localStock } from "@/views/loyalty/shared/classes/local_stock"
import { AccountService } from "@/views/loyalty/shared/services/account-service"

export default {
  name: "UserProfileAccountList",
  data: () => ({
    accountService: null,
    customerId: null,
    userProfile: {},
    upAccountCampaignList: [], // userProfileAccountCampaign
  }),
  beforeMount () {
    this.accountService = new AccountService()
    this.customerId = localStorage.getItem('customer')
    this.userProfile = localStock.getItem('userProfile')
  },
  async mounted () {
    this.upAccountCampaignList = await this.accountService.getAccrualAccountActive(this.customerId, this.userProfile.userProfileId)
    console.log('this.upAccountCampaignList:', this.upAccountCampaignList)
  },
  methods: {
    onGetTransaction (campaign) {
      console.log('campaign:', campaign)
      localStock.setItem('campaign', campaign)
      this.$router.push({ name: 'CrowdTransaction' })
    }
  }
}
</script>

<style scoped>
.campaign-name {
  word-break: break-all;
  height: 80pt;
  /*color: #03A9F4;*/
  color: black;
  font-size: 200%;
  font-weight: bold;
  font-family: serif;
  line-height: 100%;
}
.campaign-border {
  border: 1px solid black; /*#E1F5FE;*/
  border-radius: 10%;
}
.loyalty-amount {
  color: black;
  font-weight: bold;
  text-align: center;
}
.loyalty-bonus {
  color: black;
  text-align: center;
}
</style>
